import { AfterViewInit, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalMediaPipComponent } from '@base/components/modal-media-pip/modal-media-pip.component';
import { SessionService } from '@base/services/private/session.service';
import { TranslateService } from '@base/services/private/translate.service';
import { SupportedLanguages } from '@config/supported-languages.enum';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ModalMediaPipComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  private readonly translateSrv = inject(TranslateService);
  private readonly sessionSrv = inject(SessionService);
  title = 'web-app';

  ngAfterViewInit(): void {
    this.checkLanguage();
  }

  checkLanguage(): void {
    const lang = this.sessionSrv.getItem('lang');
    if (!lang) {
      this.translateSrv.setLanguage(SupportedLanguages.EN);
    }
  }
}
